import { Viewer } from './Viewer';
export function createViewer(canvasId) {
    return new Viewer(canvasId);
}
